import { ProviderType } from "@redotech/redo-integrations-definitions-common/integration/integration-schema-definition";
import {
  array,
  number,
  object,
  string,
  union,
  enum as zEnum,
  null as zNull,
  type infer as zInfer,
} from "zod";

const providerTypeValues = [
  ProviderType.Refund,
  ProviderType.Shipping,
  ProviderType.ReturnSync,
] as const;

const returnSyncInput = object({
  returnShippingMethodId: number().int().positive().optional(),
  providerCode: string().optional(),
}).optional();

export const setGlobalEIntegration = {
  name: "setGlobalEIntegration" as const,
  input: union([
    // Create new integration with credentials
    object({
      apiDomain: string(),
      username: string(),
      password: string(),
      provides: array(zEnum(providerTypeValues)).optional(),
      returnSync: returnSyncInput,
    }),
    // Create new integration with GUID
    object({
      apiDomain: string(),
      GUID: string(),
      provides: array(zEnum(providerTypeValues)).optional(),
      returnSync: returnSyncInput,
    }),
    // Update existing integration (provides and/or return sync settings)
    object({
      provides: array(zEnum(providerTypeValues)).optional(),
      returnSync: returnSyncInput,
    }),
  ]),
  output: zNull(),
};

export type SetGlobalEIntegrationInput = zInfer<
  typeof setGlobalEIntegration.input
>;
